import React from 'react'
import '../../styles/filterCard.scss'
import { useAppSelector, useBindDispatch } from 'hooks'
import { colors } from 'styles/colors'
import { FilterType } from 'types/clientFiltersTypes'

export const Filter = ({
    filter,
    resetSearchValue,
    viewMoreFilters,
    onFilterSelect
}: {
    filter: FilterType
    resetSearchValue: () => void
    viewMoreFilters?: (value: React.SetStateAction<boolean>) => void
    onFilterSelect?: () => void
}) => {
    const { selectedFilter } = useAppSelector((state) => state.filterSelection)

    const { filterSelectorHandler } = useBindDispatch()

    const handleSelectFilter = (filterOption: FilterType) => {
        const isSelectingNewFilter = selectedFilter !== filterOption.filterName
        onFilterSelect?.()
        resetSearchValue()
        filterSelectorHandler({
            selectedFilter:
                isSelectingNewFilter ? filterOption.filterName : undefined
        })
        viewMoreFilters?.(false)
    }

    return (
        <div aria-label="filter">
            <input
                type="radio"
                name="filter"
                id={filter?.filterName}
                className="filters--input"
            />
            <button
                onClick={() => handleSelectFilter(filter)}
                type="button"
                className="more-filters--open-modal-btn filter"
            >
                <label
                    htmlFor={filter.filterName}
                    className={[
                        'filters--item',
                        filter.isDoubleIcon ? 'filters--double-item' : ''
                    ].join(' ')}
                    style={{
                        border:
                            selectedFilter === filter.filterName
                                ? `1px solid ${filter.activeColor}`
                                : ''
                    }}
                    aria-label={filter.filterName}
                >
                    {filter.icons.map(({ Icon, iconProps }) => (
                        <Icon
                            key={filter.filterName}
                            {...iconProps}
                            color={
                                selectedFilter === filter.filterName
                                    ? filter.activeColor
                                    : colors.mediumGrey
                            }
                        />
                    ))}
                </label>
                <p
                    className="filter--caption"
                    style={{
                        color:
                            selectedFilter === filter.filterName
                                ? filter.activeColor
                                : colors.mediumGrey
                    }}
                >
                    {filter?.caption}
                </p>
            </button>
        </div>
    )
}
